import ApiService from "@/core/services/api.service";

export default {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  submitStaffManualAttendance(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/attendance/staff/manage", payload.form)
      .then(() => {
        console.log("Updated ", payload.form);
      })
      .finally(() => context.commit("holdEmpAttStatusEditBusy"));
  },
};
